import { render, staticRenderFns } from "./TournamentParticipants.vue?vue&type=template&id=109a558f&scoped=true&"
import script from "./TournamentParticipants.vue?vue&type=script&lang=js&"
export * from "./TournamentParticipants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "109a558f",
  null
  
)

export default component.exports